import { TenantLink } from "../../../domain/proposals/settings/proposalSettings"

const updateLink = (links: TenantLink[], id: number, update: (link: TenantLink) => TenantLink): TenantLink[] => {
  return links.map(link => {
    if (link.id === id) {
      return update(link)
    }
    return link
  })
}

export const updateLinkDisplayText = (links: TenantLink[], id: number, displayText: string): TenantLink[] => {
  return updateLink(links, id, link => ({ ...link, displayText }))
}

export const updateLinkUrl = (links: TenantLink[], id: number, url: string): TenantLink[] => {
  return updateLink(links, id, link => ({ ...link, url }))
}

export const addLink = (links: TenantLink[]): TenantLink[] => {
  const newLinkId = Math.min(0, ...links.map(link => link.id)) - 1
  return [...links, { id: newLinkId, url: '', displayText: '' }]
}

export const deleteLink = (links: TenantLink[], id: number): TenantLink[] => {
  return links.filter(link => link.id !== id)
}

export const areLinksChanged = (serverLinks: TenantLink[], currentLinks: TenantLink[]): boolean => {
  if (serverLinks.length !== currentLinks.length) {
    return true
  }

  return serverLinks.some(link => {
    const match = currentLinks.find(l => l.id === link.id)
    return match?.url !== link.url || match?.displayText !== link.displayText
  })
}
